"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncState = createAsyncState;
const types_1 = require("../status/types.js");
function createAsyncState(options) {
    var _a;
    return {
        actionStatus: (_a = options === null || options === void 0 ? void 0 : options.actionStatus) !== null && _a !== void 0 ? _a : types_1.AsyncStateStatus.Idle,
        data: options === null || options === void 0 ? void 0 : options.data,
        statusCode: options === null || options === void 0 ? void 0 : options.statusCode
    };
}
//# sourceMappingURL=lib.js.map